/*!
 * jQuery & Zepto Lazy - v1.7.10
 * http://jquery.eisbehr.de/lazy/
 *
 * Copyright 2012 - 2018, Daniel 'Eisbehr' Kern
 *
 * Dual licensed under the MIT and GPL-2.0 licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl-2.0.html
 *
 * $("img.lazy").lazy();
 */

;(function(window, undefined) {
    "use strict";

    // noinspection JSUnresolvedVariable
    /**
     * library instance - here and not in construct to be shorter in minimization
     * @return void
     */
    var $ = window.jQuery || window.Zepto,

    /**
     * unique plugin instance id counter
     * @type {number}
     */
    lazyInstanceId = 0,

    /**
     * helper to register window load for jQuery 3
     * @type {boolean}
     */    
    windowLoaded = false;

    /**
     * make lazy available to jquery - and make it a bit more case-insensitive :)
     * @access public
     * @type {function}
     * @param {object} settings
     * @return {LazyPlugin}
     */
    $.fn.Lazy = $.fn.lazy = function(settings) {
        return new LazyPlugin(this, settings);
    };

    /**
     * helper to add plugins to lazy prototype configuration
     * @access public
     * @type {function}
     * @param {string|Array} names
     * @param {string|Array|function} [elements]
     * @param {function} loader
     * @return void
     */
    $.Lazy = $.lazy = function(names, elements, loader) {
        // make second parameter optional
        if ($.isFunction(elements)) {
            loader = elements;
            elements = [];
        }

        // exit here if parameter is not a callable function
        if (!$.isFunction(loader)) {
            return;
        }

        // make parameters an array of names to be sure
        names = $.isArray(names) ? names : [names];
        elements = $.isArray(elements) ? elements : [elements];

        var config = LazyPlugin.prototype.config,
            forced = config._f || (config._f = {});

        // add the loader plugin for every name
        for (var i = 0, l = names.length; i < l; i++) {
            if (config[names[i]] === undefined || $.isFunction(config[names[i]])) {
                config[names[i]] = loader;
            }
        }

        // add forced elements loader
        for (var c = 0, a = elements.length; c < a; c++) {
            forced[elements[c]] = names[0];
        }
    };

    /**
     * contains all logic and the whole element handling
     * is packed in a private function outside class to reduce memory usage, because it will not be created on every plugin instance
     * @access private
     * @type {function}
     * @param {LazyPlugin} instance
     * @param {object} config
     * @param {object|Array} items
     * @param {object} events
     * @param {string} namespace
     * @return void
     */
    function _executeLazy(instance, config, items, events, namespace) {
        /**
         * a helper to trigger the 'onFinishedAll' callback after all other events
         * @access private
         * @type {number}
         */
        var _awaitingAfterLoad = 0,

        /**
         * visible content width
         * @access private
         * @type {number}
         */
        _actualWidth = -1,

        /**
         * visible content height
         * @access private
         * @type {number}
         */
        _actualHeight = -1,

        /**
         * determine possibly detected high pixel density
         * @access private
         * @type {boolean}
         */
        _isRetinaDisplay = false, 

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _afterLoad = 'afterLoad',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _load = 'load',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _error = 'error',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _img = 'img',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _src = 'src',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _srcset = 'srcset',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _sizes = 'sizes',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _backgroundImage = 'background-image';

        /**
         * initialize plugin
         * bind loading to events or set delay time to load all items at once
         * @access private
         * @return void
         */
        function _initialize() {
            // detect actual device pixel ratio
            // noinspection JSUnresolvedVariable
            _isRetinaDisplay = window.devicePixelRatio > 1;

            // prepare all initial items
            items = _prepareItems(items);

            // if delay time is set load all items at once after delay time
            if (config.delay >= 0) {
                setTimeout(function() {
                    _lazyLoadItems(true);
                }, config.delay);
            }

            // if no delay is set or combine usage is active bind events
            if (config.delay < 0 || config.combined) {
                // create unique event function
                events.e = _throttle(config.throttle, function(event) {
                    // reset detected window size on resize event
                    if (event.type === 'resize') {
                        _actualWidth = _actualHeight = -1;
                    }

                    // execute 'lazy magic'
                    _lazyLoadItems(event.all);
                });

                // create function to add new items to instance
                events.a = function(additionalItems) {
                    additionalItems = _prepareItems(additionalItems);
                    items.push.apply(items, additionalItems);
                };

                // create function to get all instance items left
                events.g = function() {
                    // filter loaded items before return in case internal filter was not running until now
                    return (items = $(items).filter(function() {
                        return !$(this).data(config.loadedName);
                    }));
                };

                // create function to force loading elements
                events.f = function(forcedItems) {
                    for (var i = 0; i < forcedItems.length; i++) {
                        // only handle item if available in current instance
                        // use a compare function, because Zepto can't handle object parameter for filter
                        // var item = items.filter(forcedItems[i]);
                        /* jshint loopfunc: true */
                        var item = items.filter(function() {
                            return this === forcedItems[i];
                        });

                        if (item.length) {
                            _lazyLoadItems(false, item);   
                        }
                    }
                };

                // load initial items
                _lazyLoadItems();

                // bind lazy load functions to scroll and resize event
                // noinspection JSUnresolvedVariable
                $(config.appendScroll).on('scroll.' + namespace + ' resize.' + namespace, events.e);
            }
        }

        /**
         * prepare items before handle them
         * @access private
         * @param {Array|object|jQuery} items
         * @return {Array|object|jQuery}
         */
        function _prepareItems(items) {
            // fetch used configurations before loops
            var defaultImage = config.defaultImage,
                placeholder = config.placeholder,
                imageBase = config.imageBase,
                srcsetAttribute = config.srcsetAttribute,
                loaderAttribute = config.loaderAttribute,
                forcedTags = config._f || {};

            // filter items and only add those who not handled yet and got needed attributes available
            items = $(items).filter(function() {
                var element = $(this),
                    tag = _getElementTagName(this);

                return !element.data(config.handledName) && 
                       (element.attr(config.attribute) || element.attr(srcsetAttribute) || element.attr(loaderAttribute) || forcedTags[tag] !== undefined);
            })

            // append plugin instance to all elements
            .data('plugin_' + config.name, instance);

            for (var i = 0, l = items.length; i < l; i++) {
                var element = $(items[i]),
                    tag = _getElementTagName(items[i]),
                    elementImageBase = element.attr(config.imageBaseAttribute) || imageBase;

                // generate and update source set if an image base is set
                if (tag === _img && elementImageBase && element.attr(srcsetAttribute)) {
                    element.attr(srcsetAttribute, _getCorrectedSrcSet(element.attr(srcsetAttribute), elementImageBase));
                }

                // add loader to forced element types
                if (forcedTags[tag] !== undefined && !element.attr(loaderAttribute)) {
                    element.attr(loaderAttribute, forcedTags[tag]);
                }

                // set default image on every element without source
                if (tag === _img && defaultImage && !element.attr(_src)) {
                    element.attr(_src, defaultImage);
                }

                // set placeholder on every element without background image
                else if (tag !== _img && placeholder && (!element.css(_backgroundImage) || element.css(_backgroundImage) === 'none')) {
                    element.css(_backgroundImage, "url('" + placeholder + "')");
                }
            }

            return items;
        }

        /**
         * the 'lazy magic' - check all items
         * @access private
         * @param {boolean} [allItems]
         * @param {object} [forced]
         * @return void
         */
        function _lazyLoadItems(allItems, forced) {
            // skip if no items where left
            if (!items.length) {
                // destroy instance if option is enabled
                if (config.autoDestroy) {
                    // noinspection JSUnresolvedFunction
                    instance.destroy();
                }

                return;
            }

            var elements = forced || items,
                loadTriggered = false,
                imageBase = config.imageBase || '',
                srcsetAttribute = config.srcsetAttribute,
                handledName = config.handledName;

            // loop all available items
            for (var i = 0; i < elements.length; i++) {
                // item is at least in loadable area
                if (allItems || forced || _isInLoadableArea(elements[i])) {
                    var element = $(elements[i]),
                        tag = _getElementTagName(elements[i]),
                        attribute = element.attr(config.attribute),
                        elementImageBase = element.attr(config.imageBaseAttribute) || imageBase,
                        customLoader = element.attr(config.loaderAttribute);

                        // is not already handled 
                    if (!element.data(handledName) &&
                        // and is visible or visibility doesn't matter
                        (!config.visibleOnly || element.is(':visible')) && (
                        // and image source or source set attribute is available
                        (attribute || element.attr(srcsetAttribute)) && (
                            // and is image tag where attribute is not equal source or source set
                            (tag === _img && (elementImageBase + attribute !== element.attr(_src) || element.attr(srcsetAttribute) !== element.attr(_srcset))) ||
                            // or is non image tag where attribute is not equal background
                            (tag !== _img && elementImageBase + attribute !== element.css(_backgroundImage))
                        ) ||
                        // or custom loader is available
                        customLoader))
                    {
                        // mark element always as handled as this point to prevent double handling
                        loadTriggered = true;
                        element.data(handledName, true);

                        // load item
                        _handleItem(element, tag, elementImageBase, customLoader);
                    }
                }
            }

            // when something was loaded remove them from remaining items
            if (loadTriggered) {
                items = $(items).filter(function() {
                    return !$(this).data(handledName);
                });
            }
        }

        /**
         * load the given element the lazy way
         * @access private
         * @param {object} element
         * @param {string} tag
         * @param {string} imageBase
         * @param {function} [customLoader]
         * @return void
         */
        function _handleItem(element, tag, imageBase, customLoader) {
            // increment count of items waiting for after load
            ++_awaitingAfterLoad;

            // extended error callback for correct 'onFinishedAll' handling
            var errorCallback = function() {
                _triggerCallback('onError', element);
                _reduceAwaiting();

                // prevent further callback calls
                errorCallback = $.noop;
            };

            // trigger function before loading image
            _triggerCallback('beforeLoad', element);

            // fetch all double used data here for better code minimization
            var srcAttribute = config.attribute,
                srcsetAttribute = config.srcsetAttribute,
                sizesAttribute = config.sizesAttribute,
                retinaAttribute = config.retinaAttribute,
                removeAttribute = config.removeAttribute,
                loadedName = config.loadedName,
                elementRetina = element.attr(retinaAttribute);

            // handle custom loader
            if (customLoader) {
                // on load callback
                var loadCallback = function() {
                    // remove attribute from element
                    if (removeAttribute) {
                        element.removeAttr(config.loaderAttribute);
                    }

                    // mark element as loaded
                    element.data(loadedName, true);

                    // call after load event
                    _triggerCallback(_afterLoad, element);

                    // remove item from waiting queue and possibly trigger finished event
                    // it's needed to be asynchronous to run after filter was in _lazyLoadItems
                    setTimeout(_reduceAwaiting, 1);

                    // prevent further callback calls
                    loadCallback = $.noop;
                };

                // bind error event to trigger callback and reduce waiting amount
                element.off(_error).one(_error, errorCallback)

                // bind after load callback to element
                .one(_load, loadCallback);

                // trigger custom loader and handle response
                if (!_triggerCallback(customLoader, element, function(response) {
                    if(response) {
                        element.off(_load);
                        loadCallback();
                    }
                    else {
                        element.off(_error);
                        errorCallback();
                    }
                })) {
                    element.trigger(_error);
                }
            }

            // handle images
            else {
                // create image object
                var imageObj = $(new Image());

                // bind error event to trigger callback and reduce waiting amount
                imageObj.one(_error, errorCallback)

                // bind after load callback to image
                .one(_load, function() {
                    // remove element from view
                    element.hide();

                    // set image back to element
                    // do it as single 'attr' calls, to be sure 'src' is set after 'srcset'
                    if (tag === _img) {
                        element.attr(_sizes, imageObj.attr(_sizes))
                               .attr(_srcset, imageObj.attr(_srcset))
                               .attr(_src, imageObj.attr(_src));
                    }
                    else {
                        element.css(_backgroundImage, "url('" + imageObj.attr(_src) + "')");
                    }

                    // bring it back with some effect!
                    element[config.effect](config.effectTime);

                    // remove attribute from element
                    if (removeAttribute) {
                        element.removeAttr(srcAttribute + ' ' + srcsetAttribute + ' ' + retinaAttribute + ' ' + config.imageBaseAttribute);

                        // only remove 'sizes' attribute, if it was a custom one
                        if (sizesAttribute !== _sizes) {
                            element.removeAttr(sizesAttribute);
                        }
                    }

                    // mark element as loaded
                    element.data(loadedName, true);

                    // call after load event
                    _triggerCallback(_afterLoad, element);

                    // cleanup image object
                    imageObj.remove();

                    // remove item from waiting queue and possibly trigger finished event
                    _reduceAwaiting();
                });

                // set sources
                // do it as single 'attr' calls, to be sure 'src' is set after 'srcset'
                var imageSrc = (_isRetinaDisplay && elementRetina ? elementRetina : element.attr(srcAttribute)) || '';
                imageObj.attr(_sizes, element.attr(sizesAttribute))
                        .attr(_srcset, element.attr(srcsetAttribute))
                        .attr(_src, imageSrc ? imageBase + imageSrc : null);

                // call after load even on cached image
                imageObj.complete && imageObj.trigger(_load); // jshint ignore : line
            }
        }

        /**
         * check if the given element is inside the current viewport or threshold
         * @access private
         * @param {object} element
         * @return {boolean}
         */
        function _isInLoadableArea(element) {
            var elementBound = element.getBoundingClientRect(),
                direction    = config.scrollDirection,
                threshold    = config.threshold,
                vertical     = // check if element is in loadable area from top
                               ((_getActualHeight() + threshold) > elementBound.top) &&
                               // check if element is even in loadable are from bottom
                               (-threshold < elementBound.bottom),
                horizontal   = // check if element is in loadable area from left
                               ((_getActualWidth() + threshold) > elementBound.left) &&
                               // check if element is even in loadable area from right
                               (-threshold < elementBound.right);

            if (direction === 'vertical') {
                return vertical;
            }
            else if (direction === 'horizontal') {
                return horizontal;
            }

            return vertical && horizontal;
        }

        /**
         * receive the current viewed width of the browser
         * @access private
         * @return {number}
         */
        function _getActualWidth() {
            return _actualWidth >= 0 ? _actualWidth : (_actualWidth = $(window).width());
        }

        /**
         * receive the current viewed height of the browser
         * @access private
         * @return {number}
         */
        function _getActualHeight() {
            return _actualHeight >= 0 ? _actualHeight : (_actualHeight = $(window).height());
        }

        /**
         * get lowercase tag name of an element
         * @access private
         * @param {object} element
         * @returns {string}
         */
        function _getElementTagName(element) {
            return element.tagName.toLowerCase();
        }

        /**
         * prepend image base to all srcset entries
         * @access private
         * @param {string} srcset
         * @param {string} imageBase
         * @returns {string}
         */
        function _getCorrectedSrcSet(srcset, imageBase) {
            if (imageBase) {
                // trim, remove unnecessary spaces and split entries
                var entries = srcset.split(',');
                srcset = '';

                for (var i = 0, l = entries.length; i < l; i++) {
                    srcset += imageBase + entries[i].trim() + (i !== l - 1 ? ',' : '');
                }
            }

            return srcset;
        }

        /**
         * helper function to throttle down event triggering
         * @access private
         * @param {number} delay
         * @param {function} callback
         * @return {function}
         */
        function _throttle(delay, callback) {
            var timeout,
                lastExecute = 0;

            return function(event, ignoreThrottle) {
                var elapsed = +new Date() - lastExecute;

                function run() {
                    lastExecute = +new Date();
                    // noinspection JSUnresolvedFunction
                    callback.call(instance, event);
                }

                timeout && clearTimeout(timeout); // jshint ignore : line

                if (elapsed > delay || !config.enableThrottle || ignoreThrottle) {
                    run();
                }
                else {
                    timeout = setTimeout(run, delay - elapsed);
                }
            };
        }

        /**
         * reduce count of awaiting elements to 'afterLoad' event and fire 'onFinishedAll' if reached zero
         * @access private
         * @return void
         */
        function _reduceAwaiting() {
            --_awaitingAfterLoad;

            // if no items were left trigger finished event
            if (!items.length && !_awaitingAfterLoad) {
                _triggerCallback('onFinishedAll');
            }
        }

        /**
         * single implementation to handle callbacks, pass element and set 'this' to current instance
         * @access private
         * @param {string|function} callback
         * @param {object} [element]
         * @param {*} [args]
         * @return {boolean}
         */
        function _triggerCallback(callback, element, args) {
            if ((callback = config[callback])) {
                // jQuery's internal '$(arguments).slice(1)' are causing problems at least on old iPads
                // below is shorthand of 'Array.prototype.slice.call(arguments, 1)'
                callback.apply(instance, [].slice.call(arguments, 1));
                return true;
            }

            return false;
        }

        // if event driven or window is already loaded don't wait for page loading
        if (config.bind === 'event' || windowLoaded) {
            _initialize();
        }

        // otherwise load initial items and start lazy after page load
        else {
            // noinspection JSUnresolvedVariable
            $(window).on(_load + '.' + namespace, _initialize);
        }  
    }

    /**
     * lazy plugin class constructor
     * @constructor
     * @access private
     * @param {object} elements
     * @param {object} settings
     * @return {object|LazyPlugin}
     */
    function LazyPlugin(elements, settings) {
        /**
         * this lazy plugin instance
         * @access private
         * @type {object|LazyPlugin|LazyPlugin.prototype}
         */
        var _instance = this,

        /**
         * this lazy plugin instance configuration
         * @access private
         * @type {object}
         */
        _config = $.extend({}, _instance.config, settings),

        /**
         * instance generated event executed on container scroll or resize
         * packed in an object to be referenceable and short named because properties will not be minified
         * @access private
         * @type {object}
         */
        _events = {},

        /**
         * unique namespace for instance related events
         * @access private
         * @type {string}
         */
        _namespace = _config.name + '-' + (++lazyInstanceId);

        // noinspection JSUndefinedPropertyAssignment
        /**
         * wrapper to get or set an entry from plugin instance configuration
         * much smaller on minify as direct access
         * @access public
         * @type {function}
         * @param {string} entryName
         * @param {*} [value]
         * @return {LazyPlugin|*}
         */
        _instance.config = function(entryName, value) {
            if (value === undefined) {
                return _config[entryName];
            }

            _config[entryName] = value;
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * add additional items to current instance
         * @access public
         * @param {Array|object|string} items
         * @return {LazyPlugin}
         */
        _instance.addItems = function(items) {
            _events.a && _events.a($.type(items) === 'string' ? $(items) : items); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * get all left items of this instance
         * @access public
         * @returns {object}
         */
        _instance.getItems = function() {
            return _events.g ? _events.g() : {};
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force lazy to load all items in loadable area right now
         * by default without throttle
         * @access public
         * @type {function}
         * @param {boolean} [useThrottle]
         * @return {LazyPlugin}
         */
        _instance.update = function(useThrottle) {
            _events.e && _events.e({}, !useThrottle); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force element(s) to load directly, ignoring the viewport
         * @access public
         * @param {Array|object|string} items
         * @return {LazyPlugin}
         */
        _instance.force = function(items) {
            _events.f && _events.f($.type(items) === 'string' ? $(items) : items); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force lazy to load all available items right now
         * this call ignores throttling
         * @access public
         * @type {function}
         * @return {LazyPlugin}
         */
        _instance.loadAll = function() {
            _events.e && _events.e({all: true}, true); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * destroy this plugin instance
         * @access public
         * @type {function}
         * @return undefined
         */
        _instance.destroy = function() {
            // unbind instance generated events
            // noinspection JSUnresolvedFunction, JSUnresolvedVariable
            $(_config.appendScroll).off('.' + _namespace, _events.e);
            // noinspection JSUnresolvedVariable
            $(window).off('.' + _namespace);

            // clear events
            _events = {};

            return undefined;
        };

        // start using lazy and return all elements to be chainable or instance for further use
        // noinspection JSUnresolvedVariable
        _executeLazy(_instance, _config, elements, _events, _namespace);
        return _config.chainable ? elements : _instance;
    }

    /**
     * settings and configuration data
     * @access public
     * @type {object|*}
     */
    LazyPlugin.prototype.config = {
        // general
        name               : 'lazy',
        chainable          : true,
        autoDestroy        : true,
        bind               : 'load',
        threshold          : 500,
        visibleOnly        : false,
        appendScroll       : window,
        scrollDirection    : 'both',
        imageBase          : null,
        defaultImage       : 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
        placeholder        : null,
        delay              : -1,
        combined           : false,

        // attributes
        attribute          : 'data-src',
        srcsetAttribute    : 'data-srcset',
        sizesAttribute     : 'data-sizes',
        retinaAttribute    : 'data-retina',
        loaderAttribute    : 'data-loader',
        imageBaseAttribute : 'data-imagebase',
        removeAttribute    : true,
        handledName        : 'handled',
        loadedName         : 'loaded',

        // effect
        effect             : 'show',
        effectTime         : 0,

        // throttle
        enableThrottle     : true,
        throttle           : 250,

        // callbacks
        beforeLoad         : undefined,
        afterLoad          : undefined,
        onError            : undefined,
        onFinishedAll      : undefined
    };

    // register window load event globally to prevent not loading elements
    // since jQuery 3.X ready state is fully async and may be executed after 'load' 
    $(window).on('load', function() {
        windowLoaded = true;
    });
})(window);
/*!
 * jQuery & Zepto Lazy - iFrame Plugin - v1.5
 * http://jquery.eisbehr.de/lazy/
 *
 * Copyright 2012 - 2018, Daniel 'Eisbehr' Kern
 *
 * Dual licensed under the MIT and GPL-2.0 licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl-2.0.html
 */
;(function($) {
    // load iframe content, like:
    // <iframe data-src="iframe.html"></iframe>
    //
    // enable content error check with:
    // <iframe data-src="iframe.html" data-error-detect="true"></iframe>
    $.lazy(['frame', 'iframe'], 'iframe', function(element, response) {
        var instance = this;

        if (element[0].tagName.toLowerCase() === 'iframe') {
            var srcAttr = 'data-src',
                errorDetectAttr = 'data-error-detect',
                errorDetect = element.attr(errorDetectAttr);

            // default way, just replace the 'src' attribute
            if (errorDetect !== 'true' && errorDetect !== '1') {
                // set iframe source
                element.attr('src', element.attr(srcAttr));

                // remove attributes
                if (instance.config('removeAttribute')) {
                    element.removeAttr(srcAttr + ' ' + errorDetectAttr);
                }
            }

            // extended way, even check if the document is available
            else {
                $.ajax({
                    url: element.attr(srcAttr),
                    dataType: 'html',
                    crossDomain: true,
                    xhrFields: {withCredentials: true},

                    /**
                     * success callback
                     * @access private
                     * @param {*} content
                     * @return {void}
                     */
                    success: function(content) {
                        // set responded data to element's inner html
                        element.html(content)

                        // change iframe src
                        .attr('src', element.attr(srcAttr));

                        // remove attributes
                        if (instance.config('removeAttribute')) {
                            element.removeAttr(srcAttr + ' ' + errorDetectAttr);
                        }
                    },

                    /**
                     * error callback
                     * @access private
                     * @return {void}
                     */
                    error: function() {
                        // pass error state to lazy
                        // use response function for Zepto
                        response(false);
                    }
                });
            }
        }

        else {
            // pass error state to lazy
            // use response function for Zepto
            response(false);
        }
    });
})(window.jQuery || window.Zepto);
/**
 * simplebar - v6.2.7
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */

var SimpleBar=function(){"use strict";var t=function(e,i){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i])},t(e,i)};var e="object"==typeof global&&global&&global.Object===Object&&global,i="object"==typeof self&&self&&self.Object===Object&&self,s=e||i||Function("return this")(),r=s.Symbol,l=Object.prototype,o=l.hasOwnProperty,n=l.toString,a=r?r.toStringTag:void 0;var c=Object.prototype.toString;var h=r?r.toStringTag:void 0;function u(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":h&&h in Object(t)?function(t){var e=o.call(t,a),i=t[a];try{t[a]=void 0;var s=!0}catch(t){}var r=n.call(t);return s&&(e?t[a]=i:delete t[a]),r}(t):function(t){return c.call(t)}(t)}var d=/\s/;var p=/^\s+/;function v(t){return t?t.slice(0,function(t){for(var e=t.length;e--&&d.test(t.charAt(e)););return e}(t)+1).replace(p,""):t}function f(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}var m=/^[-+]0x[0-9a-f]+$/i,b=/^0b[01]+$/i,g=/^0o[0-7]+$/i,x=parseInt;function y(t){if("number"==typeof t)return t;if(function(t){return"symbol"==typeof t||function(t){return null!=t&&"object"==typeof t}(t)&&"[object Symbol]"==u(t)}(t))return NaN;if(f(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=f(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=v(t);var i=b.test(t);return i||g.test(t)?x(t.slice(2),i?2:8):m.test(t)?NaN:+t}var E=function(){return s.Date.now()},O=Math.max,w=Math.min;function S(t,e,i){var s,r,l,o,n,a,c=0,h=!1,u=!1,d=!0;if("function"!=typeof t)throw new TypeError("Expected a function");function p(e){var i=s,l=r;return s=r=void 0,c=e,o=t.apply(l,i)}function v(t){return c=t,n=setTimeout(b,e),h?p(t):o}function m(t){var i=t-a;return void 0===a||i>=e||i<0||u&&t-c>=l}function b(){var t=E();if(m(t))return g(t);n=setTimeout(b,function(t){var i=e-(t-a);return u?w(i,l-(t-c)):i}(t))}function g(t){return n=void 0,d&&s?p(t):(s=r=void 0,o)}function x(){var t=E(),i=m(t);if(s=arguments,r=this,a=t,i){if(void 0===n)return v(a);if(u)return clearTimeout(n),n=setTimeout(b,e),p(a)}return void 0===n&&(n=setTimeout(b,e)),o}return e=y(e)||0,f(i)&&(h=!!i.leading,l=(u="maxWait"in i)?O(y(i.maxWait)||0,e):l,d="trailing"in i?!!i.trailing:d),x.cancel=function(){void 0!==n&&clearTimeout(n),c=0,s=a=r=n=void 0},x.flush=function(){return void 0===n?o:g(E())},x}var A=function(){return A=Object.assign||function(t){for(var e,i=1,s=arguments.length;i<s;i++)for(var r in e=arguments[i])Object.prototype.hasOwnProperty.call(e,r)&&(t[r]=e[r]);return t},A.apply(this,arguments)};function k(t){return t&&t.ownerDocument&&t.ownerDocument.defaultView?t.ownerDocument.defaultView:window}function W(t){return t&&t.ownerDocument?t.ownerDocument:document}var M=function(t){return Array.prototype.reduce.call(t,(function(t,e){var i=e.name.match(/data-simplebar-(.+)/);if(i){var s=i[1].replace(/\W+(.)/g,(function(t,e){return e.toUpperCase()}));switch(e.value){case"true":t[s]=!0;break;case"false":t[s]=!1;break;case void 0:t[s]=!0;break;default:t[s]=e.value}}return t}),{})};function N(t,e){var i;t&&(i=t.classList).add.apply(i,e.split(" "))}function L(t,e){t&&e.split(" ").forEach((function(e){t.classList.remove(e)}))}function z(t){return".".concat(t.split(" ").join("."))}var C=!("undefined"==typeof window||!window.document||!window.document.createElement),T=Object.freeze({__proto__:null,addClasses:N,canUseDOM:C,classNamesToQuery:z,getElementDocument:W,getElementWindow:k,getOptions:M,removeClasses:L}),D=null,R=null;function V(){if(null===D){if("undefined"==typeof document)return D=0;var t=document.body,e=document.createElement("div");e.classList.add("simplebar-hide-scrollbar"),t.appendChild(e);var i=e.getBoundingClientRect().right;t.removeChild(e),D=i}return D}C&&window.addEventListener("resize",(function(){R!==window.devicePixelRatio&&(R=window.devicePixelRatio,D=null)}));var H=k,j=W,B=M,_=N,q=L,P=z,X=function(){function t(e,i){void 0===i&&(i={});var s=this;if(this.removePreventClickId=null,this.minScrollbarWidth=20,this.stopScrollDelay=175,this.isScrolling=!1,this.isMouseEntering=!1,this.isDragging=!1,this.scrollXTicking=!1,this.scrollYTicking=!1,this.wrapperEl=null,this.contentWrapperEl=null,this.contentEl=null,this.offsetEl=null,this.maskEl=null,this.placeholderEl=null,this.heightAutoObserverWrapperEl=null,this.heightAutoObserverEl=null,this.rtlHelpers=null,this.scrollbarWidth=0,this.resizeObserver=null,this.mutationObserver=null,this.elStyles=null,this.isRtl=null,this.mouseX=0,this.mouseY=0,this.onMouseMove=function(){},this.onWindowResize=function(){},this.onStopScrolling=function(){},this.onMouseEntered=function(){},this.onScroll=function(){var t=H(s.el);s.scrollXTicking||(t.requestAnimationFrame(s.scrollX),s.scrollXTicking=!0),s.scrollYTicking||(t.requestAnimationFrame(s.scrollY),s.scrollYTicking=!0),s.isScrolling||(s.isScrolling=!0,_(s.el,s.classNames.scrolling)),s.showScrollbar("x"),s.showScrollbar("y"),s.onStopScrolling()},this.scrollX=function(){s.axis.x.isOverflowing&&s.positionScrollbar("x"),s.scrollXTicking=!1},this.scrollY=function(){s.axis.y.isOverflowing&&s.positionScrollbar("y"),s.scrollYTicking=!1},this._onStopScrolling=function(){q(s.el,s.classNames.scrolling),s.options.autoHide&&(s.hideScrollbar("x"),s.hideScrollbar("y")),s.isScrolling=!1},this.onMouseEnter=function(){s.isMouseEntering||(_(s.el,s.classNames.mouseEntered),s.showScrollbar("x"),s.showScrollbar("y"),s.isMouseEntering=!0),s.onMouseEntered()},this._onMouseEntered=function(){q(s.el,s.classNames.mouseEntered),s.options.autoHide&&(s.hideScrollbar("x"),s.hideScrollbar("y")),s.isMouseEntering=!1},this._onMouseMove=function(t){s.mouseX=t.clientX,s.mouseY=t.clientY,(s.axis.x.isOverflowing||s.axis.x.forceVisible)&&s.onMouseMoveForAxis("x"),(s.axis.y.isOverflowing||s.axis.y.forceVisible)&&s.onMouseMoveForAxis("y")},this.onMouseLeave=function(){s.onMouseMove.cancel(),(s.axis.x.isOverflowing||s.axis.x.forceVisible)&&s.onMouseLeaveForAxis("x"),(s.axis.y.isOverflowing||s.axis.y.forceVisible)&&s.onMouseLeaveForAxis("y"),s.mouseX=-1,s.mouseY=-1},this._onWindowResize=function(){s.scrollbarWidth=s.getScrollbarWidth(),s.hideNativeScrollbar()},this.onPointerEvent=function(t){var e,i;s.axis.x.track.el&&s.axis.y.track.el&&s.axis.x.scrollbar.el&&s.axis.y.scrollbar.el&&(s.axis.x.track.rect=s.axis.x.track.el.getBoundingClientRect(),s.axis.y.track.rect=s.axis.y.track.el.getBoundingClientRect(),(s.axis.x.isOverflowing||s.axis.x.forceVisible)&&(e=s.isWithinBounds(s.axis.x.track.rect)),(s.axis.y.isOverflowing||s.axis.y.forceVisible)&&(i=s.isWithinBounds(s.axis.y.track.rect)),(e||i)&&(t.stopPropagation(),"pointerdown"===t.type&&"touch"!==t.pointerType&&(e&&(s.axis.x.scrollbar.rect=s.axis.x.scrollbar.el.getBoundingClientRect(),s.isWithinBounds(s.axis.x.scrollbar.rect)?s.onDragStart(t,"x"):s.onTrackClick(t,"x")),i&&(s.axis.y.scrollbar.rect=s.axis.y.scrollbar.el.getBoundingClientRect(),s.isWithinBounds(s.axis.y.scrollbar.rect)?s.onDragStart(t,"y"):s.onTrackClick(t,"y")))))},this.drag=function(e){var i,r,l,o,n,a,c,h,u,d,p;if(s.draggedAxis&&s.contentWrapperEl){var v=s.axis[s.draggedAxis].track,f=null!==(r=null===(i=v.rect)||void 0===i?void 0:i[s.axis[s.draggedAxis].sizeAttr])&&void 0!==r?r:0,m=s.axis[s.draggedAxis].scrollbar,b=null!==(o=null===(l=s.contentWrapperEl)||void 0===l?void 0:l[s.axis[s.draggedAxis].scrollSizeAttr])&&void 0!==o?o:0,g=parseInt(null!==(a=null===(n=s.elStyles)||void 0===n?void 0:n[s.axis[s.draggedAxis].sizeAttr])&&void 0!==a?a:"0px",10);e.preventDefault(),e.stopPropagation();var x=("y"===s.draggedAxis?e.pageY:e.pageX)-(null!==(h=null===(c=v.rect)||void 0===c?void 0:c[s.axis[s.draggedAxis].offsetAttr])&&void 0!==h?h:0)-s.axis[s.draggedAxis].dragOffset,y=(x="x"===s.draggedAxis&&s.isRtl?(null!==(d=null===(u=v.rect)||void 0===u?void 0:u[s.axis[s.draggedAxis].sizeAttr])&&void 0!==d?d:0)-m.size-x:x)/(f-m.size)*(b-g);"x"===s.draggedAxis&&s.isRtl&&(y=(null===(p=t.getRtlHelpers())||void 0===p?void 0:p.isScrollingToNegative)?-y:y),s.contentWrapperEl[s.axis[s.draggedAxis].scrollOffsetAttr]=y}},this.onEndDrag=function(t){s.isDragging=!1;var e=j(s.el),i=H(s.el);t.preventDefault(),t.stopPropagation(),q(s.el,s.classNames.dragging),s.onStopScrolling(),e.removeEventListener("mousemove",s.drag,!0),e.removeEventListener("mouseup",s.onEndDrag,!0),s.removePreventClickId=i.setTimeout((function(){e.removeEventListener("click",s.preventClick,!0),e.removeEventListener("dblclick",s.preventClick,!0),s.removePreventClickId=null}))},this.preventClick=function(t){t.preventDefault(),t.stopPropagation()},this.el=e,this.options=A(A({},t.defaultOptions),i),this.classNames=A(A({},t.defaultOptions.classNames),i.classNames),this.axis={x:{scrollOffsetAttr:"scrollLeft",sizeAttr:"width",scrollSizeAttr:"scrollWidth",offsetSizeAttr:"offsetWidth",offsetAttr:"left",overflowAttr:"overflowX",dragOffset:0,isOverflowing:!0,forceVisible:!1,track:{size:null,el:null,rect:null,isVisible:!1},scrollbar:{size:null,el:null,rect:null,isVisible:!1}},y:{scrollOffsetAttr:"scrollTop",sizeAttr:"height",scrollSizeAttr:"scrollHeight",offsetSizeAttr:"offsetHeight",offsetAttr:"top",overflowAttr:"overflowY",dragOffset:0,isOverflowing:!0,forceVisible:!1,track:{size:null,el:null,rect:null,isVisible:!1},scrollbar:{size:null,el:null,rect:null,isVisible:!1}}},"object"!=typeof this.el||!this.el.nodeName)throw new Error("Argument passed to SimpleBar must be an HTML element instead of ".concat(this.el));this.onMouseMove=function(t,e,i){var s=!0,r=!0;if("function"!=typeof t)throw new TypeError("Expected a function");return f(i)&&(s="leading"in i?!!i.leading:s,r="trailing"in i?!!i.trailing:r),S(t,e,{leading:s,maxWait:e,trailing:r})}(this._onMouseMove,64),this.onWindowResize=S(this._onWindowResize,64,{leading:!0}),this.onStopScrolling=S(this._onStopScrolling,this.stopScrollDelay),this.onMouseEntered=S(this._onMouseEntered,this.stopScrollDelay),this.init()}return t.getRtlHelpers=function(){if(t.rtlHelpers)return t.rtlHelpers;var e=document.createElement("div");e.innerHTML='<div class="simplebar-dummy-scrollbar-size"><div></div></div>';var i=e.firstElementChild,s=null==i?void 0:i.firstElementChild;if(!s)return null;document.body.appendChild(i),i.scrollLeft=0;var r=t.getOffset(i),l=t.getOffset(s);i.scrollLeft=-999;var o=t.getOffset(s);return document.body.removeChild(i),t.rtlHelpers={isScrollOriginAtZero:r.left!==l.left,isScrollingToNegative:l.left!==o.left},t.rtlHelpers},t.prototype.getScrollbarWidth=function(){try{return this.contentWrapperEl&&"none"===getComputedStyle(this.contentWrapperEl,"::-webkit-scrollbar").display||"scrollbarWidth"in document.documentElement.style||"-ms-overflow-style"in document.documentElement.style?0:V()}catch(t){return V()}},t.getOffset=function(t){var e=t.getBoundingClientRect(),i=j(t),s=H(t);return{top:e.top+(s.pageYOffset||i.documentElement.scrollTop),left:e.left+(s.pageXOffset||i.documentElement.scrollLeft)}},t.prototype.init=function(){C&&(this.initDOM(),this.rtlHelpers=t.getRtlHelpers(),this.scrollbarWidth=this.getScrollbarWidth(),this.recalculate(),this.initListeners())},t.prototype.initDOM=function(){var t,e;this.wrapperEl=this.el.querySelector(P(this.classNames.wrapper)),this.contentWrapperEl=this.options.scrollableNode||this.el.querySelector(P(this.classNames.contentWrapper)),this.contentEl=this.options.contentNode||this.el.querySelector(P(this.classNames.contentEl)),this.offsetEl=this.el.querySelector(P(this.classNames.offset)),this.maskEl=this.el.querySelector(P(this.classNames.mask)),this.placeholderEl=this.findChild(this.wrapperEl,P(this.classNames.placeholder)),this.heightAutoObserverWrapperEl=this.el.querySelector(P(this.classNames.heightAutoObserverWrapperEl)),this.heightAutoObserverEl=this.el.querySelector(P(this.classNames.heightAutoObserverEl)),this.axis.x.track.el=this.findChild(this.el,"".concat(P(this.classNames.track)).concat(P(this.classNames.horizontal))),this.axis.y.track.el=this.findChild(this.el,"".concat(P(this.classNames.track)).concat(P(this.classNames.vertical))),this.axis.x.scrollbar.el=(null===(t=this.axis.x.track.el)||void 0===t?void 0:t.querySelector(P(this.classNames.scrollbar)))||null,this.axis.y.scrollbar.el=(null===(e=this.axis.y.track.el)||void 0===e?void 0:e.querySelector(P(this.classNames.scrollbar)))||null,this.options.autoHide||(_(this.axis.x.scrollbar.el,this.classNames.visible),_(this.axis.y.scrollbar.el,this.classNames.visible))},t.prototype.initListeners=function(){var t,e=this,i=H(this.el);if(this.el.addEventListener("mouseenter",this.onMouseEnter),this.el.addEventListener("pointerdown",this.onPointerEvent,!0),this.el.addEventListener("mousemove",this.onMouseMove),this.el.addEventListener("mouseleave",this.onMouseLeave),null===(t=this.contentWrapperEl)||void 0===t||t.addEventListener("scroll",this.onScroll),i.addEventListener("resize",this.onWindowResize),this.contentEl){if(window.ResizeObserver){var s=!1,r=i.ResizeObserver||ResizeObserver;this.resizeObserver=new r((function(){s&&i.requestAnimationFrame((function(){e.recalculate()}))})),this.resizeObserver.observe(this.el),this.resizeObserver.observe(this.contentEl),i.requestAnimationFrame((function(){s=!0}))}this.mutationObserver=new i.MutationObserver((function(){i.requestAnimationFrame((function(){e.recalculate()}))})),this.mutationObserver.observe(this.contentEl,{childList:!0,subtree:!0,characterData:!0})}},t.prototype.recalculate=function(){if(this.heightAutoObserverEl&&this.contentEl&&this.contentWrapperEl&&this.wrapperEl&&this.placeholderEl){var t=H(this.el);this.elStyles=t.getComputedStyle(this.el),this.isRtl="rtl"===this.elStyles.direction;var e=this.contentEl.offsetWidth,i=this.heightAutoObserverEl.offsetHeight<=1,s=this.heightAutoObserverEl.offsetWidth<=1||e>0,r=this.contentWrapperEl.offsetWidth,l=this.elStyles.overflowX,o=this.elStyles.overflowY;this.contentEl.style.padding="".concat(this.elStyles.paddingTop," ").concat(this.elStyles.paddingRight," ").concat(this.elStyles.paddingBottom," ").concat(this.elStyles.paddingLeft),this.wrapperEl.style.margin="-".concat(this.elStyles.paddingTop," -").concat(this.elStyles.paddingRight," -").concat(this.elStyles.paddingBottom," -").concat(this.elStyles.paddingLeft);var n=this.contentEl.scrollHeight,a=this.contentEl.scrollWidth;this.contentWrapperEl.style.height=i?"auto":"100%",this.placeholderEl.style.width=s?"".concat(e||a,"px"):"auto",this.placeholderEl.style.height="".concat(n,"px");var c=this.contentWrapperEl.offsetHeight;this.axis.x.isOverflowing=0!==e&&a>e,this.axis.y.isOverflowing=n>c,this.axis.x.isOverflowing="hidden"!==l&&this.axis.x.isOverflowing,this.axis.y.isOverflowing="hidden"!==o&&this.axis.y.isOverflowing,this.axis.x.forceVisible="x"===this.options.forceVisible||!0===this.options.forceVisible,this.axis.y.forceVisible="y"===this.options.forceVisible||!0===this.options.forceVisible,this.hideNativeScrollbar();var h=this.axis.x.isOverflowing?this.scrollbarWidth:0,u=this.axis.y.isOverflowing?this.scrollbarWidth:0;this.axis.x.isOverflowing=this.axis.x.isOverflowing&&a>r-u,this.axis.y.isOverflowing=this.axis.y.isOverflowing&&n>c-h,this.axis.x.scrollbar.size=this.getScrollbarSize("x"),this.axis.y.scrollbar.size=this.getScrollbarSize("y"),this.axis.x.scrollbar.el&&(this.axis.x.scrollbar.el.style.width="".concat(this.axis.x.scrollbar.size,"px")),this.axis.y.scrollbar.el&&(this.axis.y.scrollbar.el.style.height="".concat(this.axis.y.scrollbar.size,"px")),this.positionScrollbar("x"),this.positionScrollbar("y"),this.toggleTrackVisibility("x"),this.toggleTrackVisibility("y")}},t.prototype.getScrollbarSize=function(t){var e,i;if(void 0===t&&(t="y"),!this.axis[t].isOverflowing||!this.contentEl)return 0;var s,r=this.contentEl[this.axis[t].scrollSizeAttr],l=null!==(i=null===(e=this.axis[t].track.el)||void 0===e?void 0:e[this.axis[t].offsetSizeAttr])&&void 0!==i?i:0,o=l/r;return s=Math.max(~~(o*l),this.options.scrollbarMinSize),this.options.scrollbarMaxSize&&(s=Math.min(s,this.options.scrollbarMaxSize)),s},t.prototype.positionScrollbar=function(e){var i,s,r;void 0===e&&(e="y");var l=this.axis[e].scrollbar;if(this.axis[e].isOverflowing&&this.contentWrapperEl&&l.el&&this.elStyles){var o=this.contentWrapperEl[this.axis[e].scrollSizeAttr],n=(null===(i=this.axis[e].track.el)||void 0===i?void 0:i[this.axis[e].offsetSizeAttr])||0,a=parseInt(this.elStyles[this.axis[e].sizeAttr],10),c=this.contentWrapperEl[this.axis[e].scrollOffsetAttr];c="x"===e&&this.isRtl&&(null===(s=t.getRtlHelpers())||void 0===s?void 0:s.isScrollOriginAtZero)?-c:c,"x"===e&&this.isRtl&&(c=(null===(r=t.getRtlHelpers())||void 0===r?void 0:r.isScrollingToNegative)?c:-c);var h=c/(o-a),u=~~((n-l.size)*h);u="x"===e&&this.isRtl?-u+(n-l.size):u,l.el.style.transform="x"===e?"translate3d(".concat(u,"px, 0, 0)"):"translate3d(0, ".concat(u,"px, 0)")}},t.prototype.toggleTrackVisibility=function(t){void 0===t&&(t="y");var e=this.axis[t].track.el,i=this.axis[t].scrollbar.el;e&&i&&this.contentWrapperEl&&(this.axis[t].isOverflowing||this.axis[t].forceVisible?(e.style.visibility="visible",this.contentWrapperEl.style[this.axis[t].overflowAttr]="scroll",this.el.classList.add("".concat(this.classNames.scrollable,"-").concat(t))):(e.style.visibility="hidden",this.contentWrapperEl.style[this.axis[t].overflowAttr]="hidden",this.el.classList.remove("".concat(this.classNames.scrollable,"-").concat(t))),this.axis[t].isOverflowing?i.style.display="block":i.style.display="none")},t.prototype.showScrollbar=function(t){void 0===t&&(t="y"),this.axis[t].isOverflowing&&!this.axis[t].scrollbar.isVisible&&(_(this.axis[t].scrollbar.el,this.classNames.visible),this.axis[t].scrollbar.isVisible=!0)},t.prototype.hideScrollbar=function(t){void 0===t&&(t="y"),this.isDragging||this.axis[t].isOverflowing&&this.axis[t].scrollbar.isVisible&&(q(this.axis[t].scrollbar.el,this.classNames.visible),this.axis[t].scrollbar.isVisible=!1)},t.prototype.hideNativeScrollbar=function(){this.offsetEl&&(this.offsetEl.style[this.isRtl?"left":"right"]=this.axis.y.isOverflowing||this.axis.y.forceVisible?"-".concat(this.scrollbarWidth,"px"):"0px",this.offsetEl.style.bottom=this.axis.x.isOverflowing||this.axis.x.forceVisible?"-".concat(this.scrollbarWidth,"px"):"0px")},t.prototype.onMouseMoveForAxis=function(t){void 0===t&&(t="y");var e=this.axis[t];e.track.el&&e.scrollbar.el&&(e.track.rect=e.track.el.getBoundingClientRect(),e.scrollbar.rect=e.scrollbar.el.getBoundingClientRect(),this.isWithinBounds(e.track.rect)?(this.showScrollbar(t),_(e.track.el,this.classNames.hover),this.isWithinBounds(e.scrollbar.rect)?_(e.scrollbar.el,this.classNames.hover):q(e.scrollbar.el,this.classNames.hover)):(q(e.track.el,this.classNames.hover),this.options.autoHide&&this.hideScrollbar(t)))},t.prototype.onMouseLeaveForAxis=function(t){void 0===t&&(t="y"),q(this.axis[t].track.el,this.classNames.hover),q(this.axis[t].scrollbar.el,this.classNames.hover),this.options.autoHide&&this.hideScrollbar(t)},t.prototype.onDragStart=function(t,e){var i;void 0===e&&(e="y"),this.isDragging=!0;var s=j(this.el),r=H(this.el),l=this.axis[e].scrollbar,o="y"===e?t.pageY:t.pageX;this.axis[e].dragOffset=o-((null===(i=l.rect)||void 0===i?void 0:i[this.axis[e].offsetAttr])||0),this.draggedAxis=e,_(this.el,this.classNames.dragging),s.addEventListener("mousemove",this.drag,!0),s.addEventListener("mouseup",this.onEndDrag,!0),null===this.removePreventClickId?(s.addEventListener("click",this.preventClick,!0),s.addEventListener("dblclick",this.preventClick,!0)):(r.clearTimeout(this.removePreventClickId),this.removePreventClickId=null)},t.prototype.onTrackClick=function(t,e){var i,s,r,l,o=this;void 0===e&&(e="y");var n=this.axis[e];if(this.options.clickOnTrack&&n.scrollbar.el&&this.contentWrapperEl){t.preventDefault();var a=H(this.el);this.axis[e].scrollbar.rect=n.scrollbar.el.getBoundingClientRect();var c=null!==(s=null===(i=this.axis[e].scrollbar.rect)||void 0===i?void 0:i[this.axis[e].offsetAttr])&&void 0!==s?s:0,h=parseInt(null!==(l=null===(r=this.elStyles)||void 0===r?void 0:r[this.axis[e].sizeAttr])&&void 0!==l?l:"0px",10),u=this.contentWrapperEl[this.axis[e].scrollOffsetAttr],d=("y"===e?this.mouseY-c:this.mouseX-c)<0?-1:1,p=-1===d?u-h:u+h,v=function(){o.contentWrapperEl&&(-1===d?u>p&&(u-=40,o.contentWrapperEl[o.axis[e].scrollOffsetAttr]=u,a.requestAnimationFrame(v)):u<p&&(u+=40,o.contentWrapperEl[o.axis[e].scrollOffsetAttr]=u,a.requestAnimationFrame(v)))};v()}},t.prototype.getContentElement=function(){return this.contentEl},t.prototype.getScrollElement=function(){return this.contentWrapperEl},t.prototype.removeListeners=function(){var t=H(this.el);this.el.removeEventListener("mouseenter",this.onMouseEnter),this.el.removeEventListener("pointerdown",this.onPointerEvent,!0),this.el.removeEventListener("mousemove",this.onMouseMove),this.el.removeEventListener("mouseleave",this.onMouseLeave),this.contentWrapperEl&&this.contentWrapperEl.removeEventListener("scroll",this.onScroll),t.removeEventListener("resize",this.onWindowResize),this.mutationObserver&&this.mutationObserver.disconnect(),this.resizeObserver&&this.resizeObserver.disconnect(),this.onMouseMove.cancel(),this.onWindowResize.cancel(),this.onStopScrolling.cancel(),this.onMouseEntered.cancel()},t.prototype.unMount=function(){this.removeListeners()},t.prototype.isWithinBounds=function(t){return this.mouseX>=t.left&&this.mouseX<=t.left+t.width&&this.mouseY>=t.top&&this.mouseY<=t.top+t.height},t.prototype.findChild=function(t,e){var i=t.matches||t.webkitMatchesSelector||t.mozMatchesSelector||t.msMatchesSelector;return Array.prototype.filter.call(t.children,(function(t){return i.call(t,e)}))[0]},t.rtlHelpers=null,t.defaultOptions={forceVisible:!1,clickOnTrack:!0,scrollbarMinSize:25,scrollbarMaxSize:0,ariaLabel:"scrollable content",tabIndex:0,classNames:{contentEl:"simplebar-content",contentWrapper:"simplebar-content-wrapper",offset:"simplebar-offset",mask:"simplebar-mask",wrapper:"simplebar-wrapper",placeholder:"simplebar-placeholder",scrollbar:"simplebar-scrollbar",track:"simplebar-track",heightAutoObserverWrapperEl:"simplebar-height-auto-observer-wrapper",heightAutoObserverEl:"simplebar-height-auto-observer",visible:"simplebar-visible",horizontal:"simplebar-horizontal",vertical:"simplebar-vertical",hover:"simplebar-hover",dragging:"simplebar-dragging",scrolling:"simplebar-scrolling",scrollable:"simplebar-scrollable",mouseEntered:"simplebar-mouse-entered"},scrollableNode:null,contentNode:null,autoHide:!0},t.getOptions=B,t.helpers=T,t}(),Y=X.helpers,F=Y.getOptions,I=Y.addClasses,U=Y.canUseDOM,$=function(e){function i(){for(var t=[],s=0;s<arguments.length;s++)t[s]=arguments[s];var r=e.apply(this,t)||this;return i.instances.set(t[0],r),r}return function(e,i){if("function"!=typeof i&&null!==i)throw new TypeError("Class extends value "+String(i)+" is not a constructor or null");function s(){this.constructor=e}t(e,i),e.prototype=null===i?Object.create(i):(s.prototype=i.prototype,new s)}(i,e),i.initDOMLoadedElements=function(){document.removeEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.removeEventListener("load",this.initDOMLoadedElements),Array.prototype.forEach.call(document.querySelectorAll("[data-simplebar]"),(function(t){"init"===t.getAttribute("data-simplebar")||i.instances.has(t)||new i(t,F(t.attributes))}))},i.removeObserver=function(){var t;null===(t=i.globalObserver)||void 0===t||t.disconnect()},i.prototype.initDOM=function(){var t,e,i,s=this;if(!Array.prototype.filter.call(this.el.children,(function(t){return t.classList.contains(s.classNames.wrapper)})).length){for(this.wrapperEl=document.createElement("div"),this.contentWrapperEl=document.createElement("div"),this.offsetEl=document.createElement("div"),this.maskEl=document.createElement("div"),this.contentEl=document.createElement("div"),this.placeholderEl=document.createElement("div"),this.heightAutoObserverWrapperEl=document.createElement("div"),this.heightAutoObserverEl=document.createElement("div"),I(this.wrapperEl,this.classNames.wrapper),I(this.contentWrapperEl,this.classNames.contentWrapper),I(this.offsetEl,this.classNames.offset),I(this.maskEl,this.classNames.mask),I(this.contentEl,this.classNames.contentEl),I(this.placeholderEl,this.classNames.placeholder),I(this.heightAutoObserverWrapperEl,this.classNames.heightAutoObserverWrapperEl),I(this.heightAutoObserverEl,this.classNames.heightAutoObserverEl);this.el.firstChild;)this.contentEl.appendChild(this.el.firstChild);this.contentWrapperEl.appendChild(this.contentEl),this.offsetEl.appendChild(this.contentWrapperEl),this.maskEl.appendChild(this.offsetEl),this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl),this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl),this.wrapperEl.appendChild(this.maskEl),this.wrapperEl.appendChild(this.placeholderEl),this.el.appendChild(this.wrapperEl),null===(t=this.contentWrapperEl)||void 0===t||t.setAttribute("tabindex",this.options.tabIndex.toString()),null===(e=this.contentWrapperEl)||void 0===e||e.setAttribute("role","region"),null===(i=this.contentWrapperEl)||void 0===i||i.setAttribute("aria-label",this.options.ariaLabel)}if(!this.axis.x.track.el||!this.axis.y.track.el){var r=document.createElement("div"),l=document.createElement("div");I(r,this.classNames.track),I(l,this.classNames.scrollbar),r.appendChild(l),this.axis.x.track.el=r.cloneNode(!0),I(this.axis.x.track.el,this.classNames.horizontal),this.axis.y.track.el=r.cloneNode(!0),I(this.axis.y.track.el,this.classNames.vertical),this.el.appendChild(this.axis.x.track.el),this.el.appendChild(this.axis.y.track.el)}X.prototype.initDOM.call(this),this.el.setAttribute("data-simplebar","init")},i.prototype.unMount=function(){X.prototype.unMount.call(this),i.instances.delete(this.el)},i.initHtmlApi=function(){this.initDOMLoadedElements=this.initDOMLoadedElements.bind(this),"undefined"!=typeof MutationObserver&&(this.globalObserver=new MutationObserver(i.handleMutations),this.globalObserver.observe(document,{childList:!0,subtree:!0})),"complete"===document.readyState||"loading"!==document.readyState&&!document.documentElement.doScroll?window.setTimeout(this.initDOMLoadedElements):(document.addEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.addEventListener("load",this.initDOMLoadedElements))},i.handleMutations=function(t){t.forEach((function(t){t.addedNodes.forEach((function(t){1===t.nodeType&&(t.hasAttribute("data-simplebar")?!i.instances.has(t)&&document.documentElement.contains(t)&&new i(t,F(t.attributes)):t.querySelectorAll("[data-simplebar]").forEach((function(t){"init"!==t.getAttribute("data-simplebar")&&!i.instances.has(t)&&document.documentElement.contains(t)&&new i(t,F(t.attributes))})))})),t.removedNodes.forEach((function(t){var e;1===t.nodeType&&("init"===t.getAttribute("data-simplebar")?!document.documentElement.contains(t)&&(null===(e=i.instances.get(t))||void 0===e||e.unMount()):Array.prototype.forEach.call(t.querySelectorAll('[data-simplebar="init"]'),(function(t){var e;!document.documentElement.contains(t)&&(null===(e=i.instances.get(t))||void 0===e||e.unMount())})))}))}))},i.instances=new WeakMap,i}(X);return U&&$.initHtmlApi(),$}();
/*! js-cookie v3.0.0 | MIT */
;
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, (function () {
    var current = global.Cookies;
    var exports = global.Cookies = factory();
    exports.noConflict = function () { global.Cookies = current; return exports; };
  }()));
}(this, (function () { 'use strict';

  /* eslint-disable no-var */
  function assign (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        target[key] = source[key];
      }
    }
    return target
  }
  /* eslint-enable no-var */

  /* eslint-disable no-var */
  var defaultConverter = {
    read: function (value) {
      return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
    },
    write: function (value) {
      return encodeURIComponent(value).replace(
        /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
        decodeURIComponent
      )
    }
  };
  /* eslint-enable no-var */

  /* eslint-disable no-var */

  function init (converter, defaultAttributes) {
    function set (key, value, attributes) {
      if (typeof document === 'undefined') {
        return
      }

      attributes = assign({}, defaultAttributes, attributes);

      if (typeof attributes.expires === 'number') {
        attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
      }
      if (attributes.expires) {
        attributes.expires = attributes.expires.toUTCString();
      }

      key = encodeURIComponent(key)
        .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
        .replace(/[()]/g, escape);

      value = converter.write(value, key);

      var stringifiedAttributes = '';
      for (var attributeName in attributes) {
        if (!attributes[attributeName]) {
          continue
        }

        stringifiedAttributes += '; ' + attributeName;

        if (attributes[attributeName] === true) {
          continue
        }

        // Considers RFC 6265 section 5.2:
        // ...
        // 3.  If the remaining unparsed-attributes contains a %x3B (";")
        //     character:
        // Consume the characters of the unparsed-attributes up to,
        // not including, the first %x3B (";") character.
        // ...
        stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
      }

      return (document.cookie = key + '=' + value + stringifiedAttributes)
    }

    function get (key) {
      if (typeof document === 'undefined' || (arguments.length && !key)) {
        return
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all.
      var cookies = document.cookie ? document.cookie.split('; ') : [];
      var jar = {};
      for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        var value = parts.slice(1).join('=');

        if (value[0] === '"') {
          value = value.slice(1, -1);
        }

        try {
          var foundKey = defaultConverter.read(parts[0]);
          jar[foundKey] = converter.read(value, foundKey);

          if (key === foundKey) {
            break
          }
        } catch (e) {}
      }

      return key ? jar[key] : jar
    }

    return Object.create(
      {
        set: set,
        get: get,
        remove: function (key, attributes) {
          set(
            key,
            '',
            assign({}, attributes, {
              expires: -1
            })
          );
        },
        withAttributes: function (attributes) {
          return init(this.converter, assign({}, this.attributes, attributes))
        },
        withConverter: function (converter) {
          return init(assign({}, this.converter, converter), this.attributes)
        }
      },
      {
        attributes: { value: Object.freeze(defaultAttributes) },
        converter: { value: Object.freeze(converter) }
      }
    )
  }

  var api = init(defaultConverter, { path: '/' });
  /* eslint-enable no-var */

  return api;

})));

jQuery('iframe').Lazy();

(function($) {
    class MWF_A11Y {
        constructor () {
            this.initKeyboardOutline();
        }
    
        initKeyboardOutline () {
            $('body').mousedown( function() {
                $('body').attr('data-input-intent', 'mouse');
            });
              
            $('body').keydown( function(e) {
                if (e.keyCode === 9) {
                    $('body').attr('data-input-intent', 'keyboard');
                }
            });
        }
    }
    /**
     * Menu script
     */
    class MWF_Menu {
        constructor() {
            this.initState();
            this.initEvents();
        }
    
        initState() {
            this.win = $(window);
            this.menuWrapper = $('.site-header');
            this.menuIcon = this.menuWrapper.find('.menu-toggle');
            this.menu = this.menuWrapper.find('.menu');
        }
    
        initEvents() {
            $(window).on('scroll', () => {
                let positionY = this.win.scrollTop();
    
                if (positionY > 48 && !this.menuWrapper.hasClass('is-fixed')) {
                    this.menuWrapper.addClass('is-fixed');
                    return;
                }
    
                if (positionY <= 48 && this.menuWrapper.hasClass('is-fixed')) {
                    this.menuWrapper.removeClass('is-fixed');
                }
            });
    
            $(window).trigger('scroll');
    
            if (this.menuIcon.length) {
                this.menuIcon.on('click', e => {
                    e.preventDefault();
                    
                    if (this.menuIcon.attr('aria-expanded') === 'false') {
                        this.menuIcon.attr('aria-expanded', 'true');
                    } else if (this.menuIcon.attr('aria-expanded') === 'true') {
                        this.menuIcon.attr('aria-expanded', 'false');
                    }
                });
            }
        }
    }
    
    /**
     * UI elements
     */
    class MWF_UI {
        constructor() {
            this.initHeaderCountDown();
            this.initExternalLinksAttributes();
            this.initMWFDialog();
            this.initTestimonialReadMore();
            this.initProductWithOpinions();
            this.initSidebarStyles();
            this.initProductCards();
            this.initMWFFakeButtons();
        }
    
        initHeaderCountDown () {
            if (!$('.js-notification-countdown').length) {
                return;
            }
    
            $('.js-notification-countdown').each((i, countdown) => {
                mwfCalculateCountdown($(countdown));
            });
        }
    
        initExternalLinksAttributes () {
            $('.page-content a, .text-content a, .post-content a').each((i, link) => {
                let linkUrl = $(link).attr('href');
    
                if (!linkUrl || linkUrl.indexOf(window.location.hostname) > -1 || linkUrl.indexOf('#') === 0) {
                    return;
                }
    
                if (!$(link).attr('target')) {
                    $(link).attr('target', '_blank');
                }
    
                let linkRel = $(link).attr('rel');
    
                if (!linkRel) {
                    $(link).attr('rel', 'noopener noreferrer');
                } else if (linkRel.indexOf('noreferrer') === -1) {
                    $(link).attr('rel', linkRel + ' noopener noreferrer');
                }
            });
        }
    
        initMWFDialog () {
            let dialog = document.querySelector('.mwf-dialog');
            let closeButton = document.querySelector('.mwf-dialog-close');
            let dialogContent = dialog.querySelector('.mwf-dialog-content');
    
            let openDialog = (event) => {
                let sourceElement= event.detail.sourceElement;
                
                if (sourceElement) {
                    dialogContent.innerHTML = sourceElement.outerHTML;
                }
    
                dialog.classList.remove('hide');
                dialog.showModal();
    
                setTimeout(() => {
                    dialog.classList.add('show');
                }, 0);
            };
    
            let closeDialog = () => {
                dialog.classList.remove('show');
                dialog.classList.add('hide');
                
                setTimeout(() => {
                    dialog.close();
                }, 325);
            };
    
            closeButton.addEventListener('click', closeDialog);
    
            dialog.addEventListener('click', (e) => {
                if (e.target === dialog) {
                    closeDialog();
                }
            });
    
            document.addEventListener('open-mwf-dialog', openDialog);
        }
    
        initTestimonialReadMore () {
            let testimonialTexts = document.querySelectorAll('.testimonial-text:not(.has-checked-height)');
    
            if (!testimonialTexts.length) {
                return;
            }
    
            testimonialTexts.forEach(textElement => {
                if (textElement.clientHeight > 0) {
                    textElement.classList.add('has-checked-height');
                }
    
                if (textElement.scrollHeight - textElement.clientHeight >= 10) {
                    textElement.classList.add('is-readmore');
                    textElement.parentNode.addEventListener('click', () => {
                        document.dispatchEvent(new CustomEvent('open-mwf-dialog', {
                            detail: { 
                                sourceElement: textElement.parentNode.parentNode 
                            }
                        }));
                    });
                }
            });
        }
    
        initProductWithOpinions () {
            let blocks = $('.product-with-opinions');
    
            if (blocks.length) {
                blocks.each((i, block) => {
                    let moreBtn = $(block).find('.button-show-more');
    
                    if (moreBtn.length) {
                        moreBtn.on('click', (e) => {
                            e.preventDefault();
                            moreBtn.parent().parent().find('.testimonial[hidden]').each((i, testimonial) => {
                                $(testimonial).removeAttr('hidden');
                                moreBtn.attr('hidden', true);
                            });
    
                            setTimeout(() => {
                                this.initTestimonialReadMore();
                            }, 0);
                        });
                    }
                });
            }
        }
    
        initSidebarStyles () {
            if (!$('.page-sidebar-wrapper, .post-sidebar-wrapper').length) {
                return;
            }
    
            window.mwfSimplebarInstance = null;
            let mediaQuery = window.matchMedia("(min-width: 1024px)");
            let self = this;
    
            function handleMediaQueryChange(e) {
                self.applySidebarStyles();
            }
    
            mediaQuery.addListener(handleMediaQueryChange);
            this.applySidebarStyles(); 
        }
    
        applySidebarStyles () {
            let sidebarWrapper = $('.page-sidebar-wrapper, .post-sidebar-wrapper');
            let windowWidth = $(window).width();
            
            if (windowWidth >= 1024) {
              sidebarWrapper.css({
                'max-height': 'calc(100vh - (120px + var(--wp-admin--admin-bar--height, 0px) + var(--mwf-topbar-offset, 0px)))'
              });
          
              if (!window.mwfSimplebarInstance) {
                window.mwfSimplebarInstance = new SimpleBar(sidebarWrapper[0], { autoHide: true });
              }
            } else {
              sidebarWrapper.css({
                'overflow': '',
                'max-height': ''
              });
          
              $(window).off('scroll');
             
              if (window.mwfSimplebarInstance) {
                window.mwfSimpleBarInstance = null;
                sidebarWrapper[0].SimpleBar = null; 
                sidebarWrapper[0].removeAttribute('data-simplebar');
                sidebarWrapper[0].innerHTML = sidebarWrapper[0].querySelector('.simplebar-content').innerHTML;
          
                setTimeout(() => {
                  window.mwfSimplebarInstance = null;
                }, 0);
              }
            }
        }
    
        initProductCards () {
            let cards = $('.eproduct-shop');
    
            if (!cards.length) {
                return;
            }
    
            for (let i = 0; i < cards.length; i++) {
                let link = cards.eq(i).find('.button, .button-secondary');
    
                if (link.length) {
                    cards.eq(i).addClass('is-clickable');
                    cards.eq(i).on('click', e => {
                        if (e.metaKey || e.ctrlKey) {
                            window.open(link.eq(0).attr('href'), '_blank');
                        } else {
                            window.location.href = link.eq(0).attr('href');
                        }
                    });
                }
            }
        }
    
        initMWFFakeButtons () {
            let fakeBtns = $('*[data-mwf-href]');
    
            for (let i = 0; i < fakeBtns.length; i++) {
                let btn = fakeBtns.eq(i);
                btn.css('cursor', 'pointer');
                btn.on('click', () => {
                    window.location.href = btn.attr('data-mwf-href');
                });
            }
        }
    }
    
    function mwfCalculateCountdown (countdown) {
        let countTo = parseInt(countdown.attr('data-timestamp-utc'), 10) * 1000;
        let currentTime = new Date().getTime();
    
        if (countTo - currentTime > 60 * 1000) {
            let diff = countTo - currentTime;
            let days = Math.floor(diff / (24 * 60 * 60 * 1000));
            let hoursDiff = diff - (days * 24 * 60 * 60 * 1000);
            let hours = (Math.floor(hoursDiff / (60 * 60 * 1000))) % 24;
            let minutesDiff = hoursDiff - (hours * 60 * 60 * 1000);
            let minutes = (Math.floor(minutesDiff / (60 * 1000))) % 60;
            let daysSuffix = days === 1 ? ' dzień' : ' dni';
            let hoursSuffix = ' godzin ';
            let minutesSuffix = ' minut ';
    
            if (hours === 1) {
                hoursSuffix = ' godzina ';
            } else if (hours === 2 || hours === 3 || hours === 4 || hours === 22 || hours === 23) {
                hoursSuffix = ' godziny ';
            }
    
            if (minutes === 1) {
                minutesSuffix = ' minuta ';
            } else if (
                minutes === 2 || minutes === 3 || minutes === 4 || 
                minutes === 22 || minutes === 23 || minutes === 24 || 
                minutes === 32 || minutes === 33 || minutes === 34 || 
                minutes === 42 || minutes === 43 || minutes === 44 || 
                minutes === 52 || minutes === 53 || minutes === 54
            ) {
                minutesSuffix = ' minuty ';
            }
    
            let outputText = '';
    
            if (days > 0) {
                outputText += days + daysSuffix;
            }
    
            if (hours > 0) {
                if (days > 0 && minutes === 0) {
                    outputText += ' i ';
                } else if (days > 0) {
                    outputText += ', ';
                }
    
                outputText += hours + hoursSuffix;
            }
    
            if (minutes > 0) {
                if (days > 0 || hours > 0) {
                    outputText += ' i ';
                }
    
                outputText += minutes + minutesSuffix;
            }
    
            countdown.text(outputText);
    
            setTimeout(() => {
                mwfCalculateCountdown (countdown);
            }, 30 * 1000);
        } else {
            countdown.text('czas minął!');
        }
    }
    class MWF_BooksList {
        constructor () {
            this.initEvents();
        }
    
        initEvents () {
            this.search = $('.books-search-form');
            this.listWrapper = $('.books-list');
            this.loadMore = $('.books-list-load-more'); 
    
            if (!(this.listWrapper.length && this.search.length)) {
                return;
            }
    
            this.items = this.listWrapper.find('.books-list-items .books-list-item');
            this.fixSearchAttributes();
            let input = this.search.find('.custom-search-input');
    
            this.displayedBooks = 10;
            this.availableBooks = this.items.length;
            this.filteredItems = null;
    
            input.on('keyup', () => { 
                this.filterBooks(input.val()); 
            });
    
            this.filterBooks(input.val());
    
            this.loadMore.on('click', e => {
                e.preventDefault();
                this.loadMoreBooks();
            });
        }
    
        fixSearchAttributes () {
            this.items.each((i, item) => {
                let searchPhrase = $(item).attr('data-title').replace(/&nbsp;/gmi, ' ').replace(/\s/gmi, ' ').toLocaleLowerCase();
                $(item).attr('data-title', searchPhrase);
            });
        }
    
        filterBooks (searchPhrase) {
            if (searchPhrase.trim() === '') {
                this.filteredItems = this.items;
                this.limitDisplayedBooks();
                return;    
            }
    
            let selector = '[data-title*="' + searchPhrase.replace(/\s/gmi, ' ').toLocaleLowerCase() + '"]';
            this.filteredItems = this.items.filter(selector);
            this.limitDisplayedBooks();
    
            if (this.filteredItems.length) {
                $('.books-list-items-empty-state').addClass('is-hidden');
            } else {
                $('.books-list-items-empty-state').removeClass('is-hidden');
            }
        }
    
        limitDisplayedBooks () {
            this.items.addClass('is-hidden');
            this.displayedBooks = 10;
            this.availableBooks = this.filteredItems.length;
    
            if (this.availableBooks > this.displayedBooks) {
                for (let i = 0; i < 10; i++) {
                    this.filteredItems.eq(i).removeClass('is-hidden');
                }
    
                this.loadMore.removeClass('is-hidden');
            } else {
                this.filteredItems.removeClass('is-hidden');
                this.loadMore.addClass('is-hidden');
            }
        }
    
        loadMoreBooks () {
            let start = this.displayedBooks;
            this.displayedBooks += 10;
    
            for (let i = start; i < this.displayedBooks; i++) {
                if (i > this.availableBooks) {
                    break;
                }
    
                this.filteredItems.eq(i).removeClass('is-hidden');
            }
    
            if (this.displayedBooks >= this.availableBooks) {
                this.loadMore.addClass('is-hidden');
            }
        }
    }
    /**
     * UTM -> window.mwfUtmData helper
     */
    class MWF_UTM {
    	constructor() {
        this.utmResults = {
          'utm_content': null,
          'utm_campaign': null,
          'utm_medium': null,
          'utm_source': null,
          'gclid': null
        };
    
        window.mwfUtmData = window.mwfUtmData || {};
    
        this.parseUtmsInUrl();
        this.setReferrer();
        this.setUtmData();
      }
    
      parseUtmsInUrl () {
        let query = window.location.href;
              
        if (query.indexOf('?') != -1){
          query = query.split('?');		
          query = query[1];
        }
    
        let parsedQuery = query.split("&");
        let allowedKeys = Object.keys(this.utmResults);
    
        for (var i = 0; i < parsedQuery.length; i++) {
          let pair = parsedQuery[i].split('=');
          let key = decodeURIComponent(pair[0]);
    
          if (key.length === 0 || allowedKeys.indexOf(key) === -1) {
            continue;
          }
    
          let value = decodeURIComponent(pair[1].replace("+"," "));
          this.utmResults[key] = value;
        }
      };
    
      setReferrer () {
        this.utmResults.referrer = document.referrer;
    
        if (!!this.utmResults.referrer) {
          this.utmResults.referrer = this.utmResults.referrer.replace(/^(?:https?:\/\/)?(?:www\.)?/i, '').split('/')[0];
          this.utmResults.referrer = this.utmResults.referrer.replace(/[^a-z0-9\-\_\.\/\+\@\?\&ąćęłńóśźż]/gmi, '');
        } else {
          this.utmResults.referrer = null;
        }
    
        if (this.utmResults.referrer === window.location.host) {
          this.utmResults.referrer = null;
        }
      }
    
      setUtmData () {
        // UTM SOURCE
        if (this.utmResults.utm_source !== null) {
          window.mwfUtmData.utm_source = this.utmResults.utm_source;
        } else if (this.utmResults.gclid !== null) {
          window.mwfUtmData.utm_source = 'google';
        } else if (!window.mwfUtmData.utm_source && this.utmResults.referrer !== null) {
          window.mwfUtmData.utm_source = this.utmResults.referrer;
          window.mwfUtmData.utm_medium = 'referral';
        }
    
        // UTM MEDIUM
        if (this.utmResults.utm_medium !== null) {
          window.mwfUtmData.utm_medium = this.utmResults.utm_medium;
        } else if (this.utmResults.gclid !== null) {
          window.mwfUtmData.utm_medium = 'cpc';
        }
    
        // UTM CAMPAIGN
        if (this.utmResults.utm_campaign !== null) {
          window.mwfUtmData.utm_campaign = this.utmResults.utm_campaign;
        }
    
        // UTM CONTENT
        if (this.utmResults.utm_content !== null) {
          window.mwfUtmData.utm_content = this.utmResults.utm_content;
        }
      }
    }
    
    class MWF_Newsletter {
        constructor () {
            if (!$('.mwf-newsletter-form').length) {
                return;
            }
    
            this.readUtmFromCookies();
        }
    
        readUtmFromCookies () {
            let form = $('.mwf-newsletter-form');
            
            if (!form.length) {
                return;
            }
    
            if (!window.mwfUtmData) {
                return;
            }
    
            let utmSource = window.mwfUtmData.utm_source;
            let utmMedium = window.mwfUtmData.utm_medium;
            let utmCampaign = window.mwfUtmData.utm_campaign;
            let utmContent = window.mwfUtmData.utm_content;
    
            if (utmSource) {
                form.find('input[name="utm_source"]').val(utmSource);
                form.find('input.enchagre-form-v2[name="UTMSource"]').val(utmSource);
            }
    
            if (utmMedium) {
                form.find('input[name="utm_medium"]').val(utmMedium);
                form.find('input.enchagre-form-v2[name="UTMMedium"]').val(utmMedium);
            }
    
            if (utmCampaign) {
                form.find('input[name="utm_campaign"]').val(utmCampaign);
                form.find('input.enchagre-form-v2[name="UTMCampaign"]').val(utmCampaign);
            }
    
            if (utmContent) {
                form.find('input[name="utm_content"]').val(utmContent);
                form.find('input.enchagre-form-v2[name="UTMContent"]').val(utmContent);
            }
        }
    }
    +/**
     * Cookie Banner
     */
    
    /*
     Connections:
     -------------------------------------------------------------------------------
     * google - GA4, Google Ads
     * facebook - Meta Pixel
     * players - every player on website: YouTube, Vimeo
     * marketing - chat, Convertbox
     * 
    */
    
    (function ($) {
        var config = {
            debugMode: true,
            userConsents: {
                google: false,
                facebook: false,
                players: false,
                marketing: false
            },
            userUUID: 'not-set',
            groups: [
                'google',
                'facebook',
                'players',
                'marketing'
            ],
            allowedGroups: []
        };
      
        var UI = {
            basicWindow: $('.mwf-cn-info'),
            extendedWindow: $('.mwf-cn-info-extended'),
            buttons: {
                basicShowExtended: $('.mwf-cn-info-button-show-extended'),
                basicAcceptAll: $('.mwf-cn-info-button-accept-all'),
                basicRejectAll: $('.mwf-cn-info-button-reject-all'),
                extendedAcceptAll: $('.mwf-cn-info-extended-button-accept-all'),
                extendedSaveConfig: $('.mwf-cn-info-extended-button-save-consent'),
                extendedNotNow: $('.mwf-cn-info-extended-button-close-without-save')
            },
            checkboxes: {
                google: $('.mwf-cn-consent-checkbox[data-consent-type="google"]'),
                facebook: $('.mwf-cn-consent-checkbox[data-consent-type="facebook"]'),
                players: $('.mwf-cn-consent-checkbox[data-consent-type="players"]'),
                marketing: $('.mwf-cn-consent-checkbox[data-consent-type="marketing"]')
            }
        };
      
        if (UI.basicWindow.length) {
            initEvents();
            initPublicAPI();
            checkConfig(config);
        }
      
        function checkConfig () {
            var configFromCookie = Cookies.get(window.mwfCNConfig.cookieName, { path: window.mwfCNConfig.path });
      
            // When no config - show popup
            if (!configFromCookie) {
                if (config.debugMode) {
                    console.log('⛔️ Consent config not found - showing popup');
                }
        
                config.userUUID = generateUUID();
                
                // Not open on privacy policy page
                if (!$(document.body).hasClass('privacy-policy')) {
                    showPopup();
                }
    
                return;
            }
      
            // otherwise - load config without showing popup
            loadConfig(configFromCookie);
        }
      
        function loadConfig (configFromCookie) {
            config.userConsents.google = configFromCookie.indexOf('google') > -1;
            config.userConsents.facebook = configFromCookie.indexOf('facebook') > -1;
            config.userConsents.players = configFromCookie.indexOf('players') > -1;
            config.userConsents.marketing = configFromCookie.indexOf('marketing') > -1;
            let configParts = configFromCookie.split('||');
    
            if (configParts[1]) {
                config.userUUID = configParts[1].replace(/[^a-zA-Z0-9\-]/gmi, '');
            } else {
                config.userUUID = generateUUID();
            }
      
            for (var i = 0; i < config.groups.length; i++) {
                var groupName = config.groups[i];
      
                if (config.userConsents[groupName]) {
                    config.allowedGroups.push(groupName);
                }
            }
      
            if (config.debugMode) {
                console.log('⚙️ Founded config:', JSON.parse(JSON.stringify(config.userConsents)));
            }
        }
      
        function initEvents () {
            $(document).find('a[href="#cookie-settings"]').on('click', e => {
                e.preventDefault();
                showExtendedPopup();
            });
      
            UI.buttons.basicShowExtended.on('click', e => {
                e.preventDefault();
                closePopup();
                showExtendedPopup();
            });
      
            UI.buttons.basicAcceptAll.on('click', e => {
                e.preventDefault();
                giveConsentForAll();
                closePopup();
            });
      
            UI.buttons.basicRejectAll.on('click', e => {
                e.preventDefault();
                resetCookieConfig();
                closePopup();
            });
      
            UI.buttons.extendedAcceptAll.on('click', e => {
                e.preventDefault();
                giveConsentForAll();
                closeExtendedPopup();
            });
      
            UI.buttons.extendedSaveConfig.on('click', e => {
                e.preventDefault();
                saveConsent();
                closeExtendedPopup();
            });
      
            UI.buttons.extendedNotNow.on('click', e => {
                e.preventDefault();
                closeExtendedPopup();
    
                var configFromCookie = Cookies.get(window.mwfCNConfig.cookieName, { path: window.mwfCNConfig.path });
      
                if (!configFromCookie) {
                    showPopup();
                }
            });
        }
      
        function setCheckboxes () {
            for (var i = 0; i < config.groups.length; i++) {
                var group = config.groups[i];
      
                if (config.userConsents[group]) {
                    UI.checkboxes[group].prop('checked', true);
                } else {
                    UI.checkboxes[group].prop('checked', false);
                }
            }
        }
      
        function initPublicAPI () {
            window.mwfCookieBanner = {
                giveConsentAndSave: function (type) {
                    giveConsentAndSave(type);
                },
                giveConsentAndSaveAndLoad: function (type) {
                    giveConsentAndSave(type, true);
                },
                showExtendedPopup: function () {
                    showExtendedPopup();
                },
                getConsentStatus: function (type) {
                    getConsentStatus(type);
                }
            };
        }
      
        function showPopup () {
            UI.basicWindow.removeClass('is-hidden');
        }
      
        function closePopup () {
            UI.basicWindow.addClass('is-hidden');
        }
      
        function showExtendedPopup () {
            UI.extendedWindow.removeClass('is-hidden');
            $(document.body).addClass('no-scroll');
            setCheckboxes();
        }
      
        function closeExtendedPopup () {
            UI.extendedWindow.addClass('is-hidden');
            $(document.body).removeClass('no-scroll');
        }
      
        function giveConsentForAll () {
            giveConsent('google');
            giveConsent('facebook');
            giveConsent('players');
            giveConsent('marketing');
            saveConsentConfigInCookie(false);
        }
      
        function giveConsent (type, forceOnLoad = false) {
            if (config.debugMode) {
                console.log('✅ User gave consent:', type);
            }
      
            // If consent has been previously given - do nothing
            if (config.allowedGroups.indexOf(type) > -1) {
                return;
            }
      
            config.userConsents[type] = true;
    
            if (type === 'google') {
                allowGoogle();
                return;
            }
    
            if (type === 'facebook') {
                allowFB();
                return;
            }
      
            if (type === 'players') {
                allowPlayers();
                return;
            }
      
            if (type === 'marketing') {
                allowMarketing();
                return;
            }
        }
      
        function giveConsentAndSave (type, forceOnLoad = false) {
            giveConsent(type, forceOnLoad);
            saveConsentConfigInCookie(false);
        }
      
        function saveConsent () {
            var consentCompare = compareConsents();
            setConsentBasedOnCheckboxes();
      
            // if some consent has been removed
            if (consentCompare === 'some-rejected') {
                saveConsentConfigInCookie(true);
                return;
            }
      
            // otherwise - if some consent has been added
            saveConsentConfigInCookie(false);
        }
      
        function setConsentBasedOnCheckboxes () {
            for (var i = 0; i < config.groups.length; i++) { 
                var group = config.groups[i];
      
                if (!!UI.checkboxes[group].prop('checked')) {
                    giveConsent(group);
                }
      
                config.userConsents[group] = !!UI.checkboxes[group].prop('checked');
            }
        }
      
        function saveConsentConfigInCookie (reloadNeeded = false) {
            var configToSave = [];
      
            for (var i = 0; i < config.groups.length; i++) {
                var group = config.groups[i];
      
                if (config.userConsents[group]) {
                    configToSave.push(group);
                }
            }
      
            if (configToSave.length) {
                Cookies.set(window.mwfCNConfig.cookieName, configToSave.join(';') + '||' + config.userUUID, { expires: 180, path: window.mwfCNConfig.path });
      
                if (config.debugMode) {
                    console.log('🍪 Consent config saved in the cookie');
                }
            } else {
                Cookies.set(window.mwfCNConfig.cookieName, 'null' + '||' + config.userUUID, { expires: 180, path: window.mwfCNConfig.path });
            }
    
            let dataToSave = {
                consent_id: config.userUUID,
                consent_revision: window.mwfCNConfig.cookieName,
                consent_content: configToSave.join(';'),
                consent_timestamp: +new Date(),
                url: window.location.pathname,
                delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
            };
          
            if ('sendBeacon' in navigator) {
                const formData = $.param(dataToSave);
                const blob = new Blob(
                    [formData], 
                    {
                        type : 'application/x-www-form-urlencoded'
                    }
                );
                navigator.sendBeacon('https://malawielkafirma.pl/wp-json/cmp/v1/save', blob);
                
                if (reloadNeeded) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                }
            } else {
                $.ajax({
                    url: 'https://malawielkafirma.pl/wp-json/cmp/v1/save',
                    type: 'POST',
                    contentType: 'application/x-www-form-urlencoded',
                    data: $.param(dataToSave),
                    success: function () {
                        if (reloadNeeded) {
                            setTimeout(() => {
                                window.location.reload();
                            }, 500);
                        }
                    },
                    fail: function () {
                        if (reloadNeeded) {
                            setTimeout(() => {
                                window.location.reload();
                            }, 500);
                        }
                    }
                });
            }
        }
      
        function resetCookieConfig () {
            Cookies.set(window.mwfCNConfig.cookieName, 'null' + '||' + config.userUUID, { expires: 180, path: window.mwfCNConfig.path });
      
            if (config.debugMode) {
              console.log('🗑 User rejected all cookies - save empty config cookie');
            }
    
            let dataToSave = {
                consent_id: config.userUUID,
                consent_revision: window.mwfCNConfig.cookieName,
                consent_content: '',
                consent_timestamp: +new Date(),
                url: window.location.pathname,
                delivery: 'sendBeacon' in navigator ? 'beacon' : 'ajax'
            };
          
            if ('sendBeacon' in navigator) {
                const formData = $.param(dataToSave);
                const blob = new Blob(
                    [formData], 
                    {
                        type : 'application/x-www-form-urlencoded'
                    }
                );
                navigator.sendBeacon('https://malawielkafirma.pl/wp-json/cmp/v1/save', blob);
            } else {
                $.ajax({
                    url: 'https://malawielkafirma.pl/wp-json/cmp/v1/save',
                    type: 'POST',
                    contentType: 'application/x-www-form-urlencoded',
                    data: $.param(dataToSave)
                });
            }
        }
      
        function compareConsents () {
            var someRejected = false;
      
            for (var i = 0; i < config.groups.length; i++) {
                var group = config.groups[i];
      
                if (config.userConsents[group] && !UI.checkboxes[group].prop('checked')) {
                    someRejected = true;
    
                    if (group === 'google' && typeof gtag === 'function') {
                        gtag('consent', 'update', {
                            ad_user_data: 'denied',
                            ad_personalization: 'denied',
                            ad_storage: 'denied',
                            analytics_storage: 'denied'
                        });
                    }
                }
            }
      
            if (someRejected) {
                if (config.debugMode) {
                    console.log('🔄 Some consents has been rejected - website reload needed');
                }
      
                return 'some-rejected';
            }
      
            if (config.debugMode) {
                console.log('ℹ️ User not rejected any consents - website reload not needed');
            }
      
            return 'some-added-or-not-changed';
        }
      
        function getConsentStatus (type) {
            return !!config.userConsents[type];
        }
      
        function allowGoogle () {
            if (window.mwfUnlocked.indexOf('google') > -1) {
                return;
            }
      
            window.mwfUnlockConsentedScript('google', 'head', true);
        }
    
        function allowFB () {
            if (window.mwfUnlocked.indexOf('facebook') > -1) {
                return;
            }
        
            window.mwfUnlockConsentedScript('facebook', 'head', true);
        }
        
        function allowPlayers () {
            if (window.mwfUnlocked.indexOf('players') > -1) {
                return;
            }
      
            window.mwfUnlockPlayers(true);
        }
        
        function allowMarketing () {
            if (window.mwfUnlocked.indexOf('marketing') > -1) {
                return;
            }
      
            window.mwfUnlockConsentedScript('marketing', 'head', true);
            window.mwfUnlockMarketing(true);
        }
    
        function generateUUID () {
            var crypto = window.crypto || window.msCrypto;
        
            if (crypto && crypto.randomUUID) {
                let uuid = crypto.randomUUID();
                return uuid;
            }
        
            if (window.Uint8Array && crypto && crypto.getRandomValues) {
                let bytes = new Uint8Array(16);
                crypto.getRandomValues(bytes);
                bytes[6] = (bytes[6] & 0x0f) | 0x40;
                bytes[8] = (bytes[8] & 0x3f) | 0x80;
                let uuid = Array.prototype.map.call(bytes, (b, i) => {
                    return ((b < 16) ? '0' : '') + b.toString(16) + (((i % 2) && (i < 10) && (i > 2)) ? "-" : "");
                }).join('');
                return uuid;
            }
        
            var dt = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = (dt + Math.random()*16)%16 | 0;
                dt = Math.floor(dt/16);
                return (c == 'x' ? r : (r&0x3|0x8)).toString(16);
            });
        
            return uuid;
        }
      })(jQuery);
    /**
     * Episodes list
     */
    
    class MWF_EpisodesList {
        constructor () {
            this.initEvents();
        }
    
        initEvents () {
            this.search = $('.episodes-search-form');
            this.listWrapper = $('.episodes-list');
            this.selectedCategory = '';
    
            if (!(this.listWrapper.length && this.search.length)) {
                return;
            }
    
            this.loadMore = $('.episodes-list-load-more'); 
            this.categorySelector = $('#episodes-list-categories');
            this.items = this.listWrapper.find('.episodes-list-item');
            this.fixSearchAttributes();
            this.input = this.search.find('.custom-search-input');
    
            this.displayedEpisodes = 20;
            this.availableEpisodes = this.items.length;
            this.filteredItems = null;
    
            this.input.on('keyup', () => { 
                this.filterEpisodes(this.input.val()); 
            });
    
            this.filterEpisodes(this.input.val());
    
            this.loadMore.on('click', e => {
                e.preventDefault();
                this.loadMoreEpisodes();
            });
    
            this.categorySelector.on('change', e => {
                this.selectedCategory = this.categorySelector.val();
                this.filterEpisodes(this.input.val());
            });
    
            let urlParams = new URLSearchParams(window.location.search);
    
            if (urlParams.has('odcinek') && urlParams.get('odcinek').match(/^[0-9]{1,3}$/gmi)) {
                this.input.val(parseInt(urlParams.get('odcinek'), 10));
                this.input.trigger('keyup');
            }
        }
    
        fixSearchAttributes () {
            this.items.each((i, item) => {
                let searchPhrase = $(item).attr('data-episode-title').replace(/&nbsp;/gmi, ' ').replace(/\s/gmi, ' ').toLocaleLowerCase();
                $(item).attr('data-episode-title', searchPhrase);
    
                $(item).find('.episodes-list-item-category').on('click', e => {
                    e.preventDefault();
                    this.input.val('');
                    this.selectedCategory = $(e.target).attr('data-category-id');
                    this.categorySelector.val(this.selectedCategory);
                    this.categorySelector.trigger('change');
    
                    $('.site-main')[0].scrollIntoView();
                });
            });
        }
    
        filterEpisodes (searchPhrase) {
            if (searchPhrase.trim() === '' && this.selectedCategory === '') {
                this.filteredItems = this.items;
                this.limitDisplayedEpisodes();
                return;    
            }
    
            if (searchPhrase.trim() === '' && this.selectedCategory !== '') {
                this.filteredItems = this.items.filter('[data-episode-category-id="' + parseInt(this.selectedCategory, 10) + '"]');
                this.limitDisplayedEpisodes();
                return;
            }
    
            if (searchPhrase.match(/^[0-9]{1,3}$/gmi)) {
                this.filteredItems = this.items.filter('[data-episode-number="' + parseInt(searchPhrase, 10) + '"]');
                this.limitDisplayedEpisodes();
                return;
            }
    
            let selector = '[data-episode-title*="' + searchPhrase.replace(/\s/gmi, ' ').toLocaleLowerCase() + '"]';
    
            if (this.selectedCategory !== '') {
                selector += '[data-episode-category-id="' + parseInt(this.selectedCategory, 10) + '"]';
            }
    
            this.filteredItems = this.items.filter(selector);
            this.limitDisplayedEpisodes();
    
            if (this.filteredItems.length) {
                $('.episodes-list-empty-state').addClass('is-hidden');
            } else {
                $('.episodes-list-empty-state').removeClass('is-hidden');
            }
        }
    
        limitDisplayedEpisodes () {
            this.items.addClass('is-hidden');
            this.displayedEpisodes = 20;
            this.availableEpisodes = this.filteredItems.length;
    
            if (this.availableEpisodes > this.displayedEpisodes) {
                for (let i = 0; i < 20; i++) {
                    this.filteredItems.eq(i).removeClass('is-hidden');
                }
    
                this.loadMore.removeClass('is-hidden');
            } else {
                this.filteredItems.removeClass('is-hidden');
                this.loadMore.addClass('is-hidden');
            }
        }
    
        loadMoreEpisodes () {
            let start = this.displayedEpisodes;
            this.displayedEpisodes += 20;
    
            for (let i = start; i < this.displayedEpisodes; i++) {
                if (i > this.availableEpisodes) {
                    break;
                }
    
                this.filteredItems.eq(i).removeClass('is-hidden');
            }
    
            if (this.displayedEpisodes >= this.availableEpisodes) {
                this.loadMore.addClass('is-hidden');
            }
        }
    }

    new MWF_A11Y();
    new MWF_UTM();
    new MWF_Menu();
    new MWF_UI();  
    new MWF_BooksList();
    new MWF_Newsletter();
    new MWF_EpisodesList();
})(jQuery);